import { useEffect } from "react"
import { DateTime } from "luxon"
import { garconClient } from "@apis/axiosClients"
import { useAuthUserDetails } from "@apis/users/useUsers"

export function useAuditInterceptor() {
  const { data: userData } = useAuthUserDetails()

  // Setup request interceptor with user data (dynamic - depends on user data)
  useEffect(() => {
    if (!userData) return

    const reqInterceptor = garconClient.interceptors.request.use((config) => {
      // Some endpoints cannot accept the audit object as the payload is being used as is to update a record
      if (config.skipAuditInterceptor) {
        return config
      }

      config.data = {
        ...config.data,
        audit: {
          user_name: userData.email,
          user_id: userData.user_id,
          source: "CRM",
          date: DateTime.now().toISO(),
        },
      }
      return config
    })

    // Cleanup fn to remove the interceptor when the component unmounts
    return () => {
      garconClient.interceptors.request.eject(reqInterceptor)
    }
  }, [userData])
}
